import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import {
  ProductTrailType,
  PeriodUnitType,
  SubscriptionsEnum,
  PurchasedEnum,
  SMESubscriptionsEnum,
  SubscribtionsType,
} from '@app/core/enums';
import { GlobalComponent, ProductTabDetails } from '@app/core/models';
import { CommonService, LocalStorageService } from '@app/core/services';
import {
  CheckProductDisable,
  GetConnectLink,
  GetIndividualProductList,
  GetProductList,
  GetProductTabDetails,
  GetSubscriptionPortalDetails,
  GetSubscriptionPortalForCapiumAddonsDetails,
} from '@app/core/store';
import { GetSmeProductList, GetSmeSubscriptionPortalDetails } from '@app/core/store/sme-products';
import { ProductAddonsComponent } from './product-addons/product-addons.component';
import { ProductFullSuiteComponent } from './product-full-suite/product-full-suite.component';
import { ProductIndividualComponent } from './product-individual/product-individual.component';
import { ProductSmeComponent } from './product-sme/product-sme.component';
import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap, take } from 'rxjs';
import { ProductCapium365Component } from './product-capium365/product-capium365/product-capium365.component';
import { AuthSessionService } from '@app/core/auth';
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
})
export class ProductsComponent implements OnInit {
  productDataList: ProductTabDetails[];
  periodUnitType = PeriodUnitType;
  frequency: number = PeriodUnitType.Month;
  addonFrequency: number = PeriodUnitType.Month;
  capium365Frequency: number = PeriodUnitType.Month;


  @ViewChild(ProductFullSuiteComponent, { static: false })
  productDetails;

  @ViewChild(ProductAddonsComponent, { static: false })
  productAddonsDetails;

  @ViewChild(ProductIndividualComponent, { static: false })
  productIndividualDetails;

  @ViewChild(ProductSmeComponent, { static: false })
  ProductSmeComponent;

  @ViewChild(ProductCapium365Component, { static: false })
  productCapium365Component;

  isShowReviewOrder: boolean;
  isPaymentDone: boolean;
  isPlanUpgraded: boolean;
  disableButton: boolean;
  isSME: boolean;
  isSMEShow: boolean;

  selectedTab: number = 0;
  showAddonTab = false;
  isSubscriptionCancelled = false;
  isAddonSubscriptionCancelled = false;
  isProductDisabled = false;
  constructor(
    public dialog: MatDialog,
    private store: Store,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    public storage: LocalStorageService,
    public commonService: CommonService,
    public globalComponent: GlobalComponent,
    public authSession: AuthSessionService,
  ) { }

  ngOnInit(): void {
    this.isSME = this.storage.get('isSME');

    if (typeof this.isSME === 'object') {
      this.isSME = false; // to make sure if isSME is null or undefined it should be false
      this.storage.set('isSME', false); // set this as false
    }

    // LocalStorageService returns {} for missing keys — never treat that as a frequency.
    this.frequency = this.normalizeFrequency(
      this.storage.get('frequency'),
      PeriodUnitType.Month
    );
    this.addonFrequency = this.frequency;
    this.capium365Frequency = this.frequency;
    this.storage.set('frequency', this.frequency);

    if (
      this.storage.get('fullSuiteAddonList') != null &&
      Object.keys(this.storage.get('fullSuiteAddonList')).length !== 0
    ) {
      // frequency already normalized above
    } else if (Object.keys(this.storage.get('cartDetails') || {}).length !== 0) {
      if (this.storage.get('cartDetails')[0].subscribtionsType === SubscribtionsType.Indidvidual) {
        this.frequency = this.normalizeFrequency(
          this.storage.get('frequency'),
          this.frequency
        );
      }
    }

    this.isPaymentDone =
      this.activatedRoute.snapshot.queryParams['state'] !== undefined;
    if (!this.isSME) {
      if (!this.isPaymentDone) {
        console.log('Payment not done - fetching subscription data');
        this.getSubscriptionData();
        this.getConnectLink();
      } else {
        console.log('Payment done - clearing cart details');
        this.globalComponent.totalCartItem.next(0);
        this.storage.removeItem('fullSuiteAddonList');
      }
      this.checkProductDisable();
    } else {
      this.getSmeSubscriptionDetailData();
    }
  }

  checkProductDisable(): void {
    this.authSession.userData$().pipe(take(1)).subscribe((userData) => {
      const userName = userData.email;
      // ProductService.checkProductDisable waits for SP identity cookies after OneLogin.
      this.store.dispatch(new CheckProductDisable(userName)).subscribe((res) => {
        this.isProductDisabled = res.product.isProductDisabled;
      });
    });
  }

  setFrequency(defaultFrequency: any, period): void {
    let frequency;
    if (defaultFrequency === ProductTrailType.TrailPeriodUnitType) {
      frequency = PeriodUnitType.Month;
    } else if (
      (defaultFrequency === PeriodUnitType.Month ||
        defaultFrequency === PeriodUnitType.Year) &&
      period === 1
    ) {
      frequency = defaultFrequency;
    } else {
      frequency = PeriodUnitType.Quarterly;
    }

    this.frequency = this.normalizeFrequency(frequency, PeriodUnitType.Month);
    this.addonFrequency = this.frequency;
    this.capium365Frequency = this.frequency;
    this.storage.set('frequency', this.frequency);
  }

  /** LocalStorageService.get returns {} when a key is missing; coerce to a valid PeriodUnitType. */
  private normalizeFrequency(value: unknown, fallback: number): number {
    if (typeof value === 'number' && !Number.isNaN(value)) {
      return value;
    }
    if (typeof value === 'string' && value.trim() !== '') {
      const parsed = Number(value);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }
    return fallback;
  }

  getConnectLink(): void {
    this.authSession.userData$().pipe(take(1)).subscribe((userData) => {
      const userName = userData.email;
      // this.store.dispatch(new GetConnectLink(userName)).subscribe();
    });
  }

  getSubscriptionData(): void {
    this.spinner.show();
    this.store.dispatch(new GetSubscriptionPortalDetails()).subscribe((x) => {
      if (x.subscriptionPortal.subscriptionPortalData.length > 0) {
        let isTrailPeriod = x.subscriptionPortal.subscriptionPortalData.some(
          (item: any) => {
            const isTrue =
              +parseInt(item.itemPrice.itemId) === +SubscriptionsEnum.trail ||
              +parseInt(item.status) === +PurchasedEnum.Cancelled;

            if (+parseInt(item.status) === +PurchasedEnum.Cancelled) {
              this.isSubscriptionCancelled = true;
            }

            return isTrue;
          }
        );

        this.disableButton =
          !isTrailPeriod && !this.isSubscriptionCancelled ? true : false;

        this.showAddonTab = !isTrailPeriod && !this.isSubscriptionCancelled;


        const storedFrequency = this.storage.get('frequency');
        if (
          storedFrequency == null ||
          typeof storedFrequency === 'object' ||
          Number.isNaN(Number(storedFrequency))
        ) {
          this.setFrequency(
            x.subscriptionPortal.subscriptionPortalData[0].itemPrice.periodUnit,
            x.subscriptionPortal.subscriptionPortalData[0].itemPrice.period
          );
        } else {
          this.frequency = this.normalizeFrequency(
            storedFrequency,
            PeriodUnitType.Month
          );
          this.addonFrequency = this.frequency;
          this.capium365Frequency = this.frequency;
        }
        

        if (Object.keys(this.storage.get('cartDetails')).length !== 0) {
          this.selectedTab =
            this.storage.get('cartDetails')[0].subscribtionsType;
        } else {
          this.selectedTab =
            x.subscriptionPortal.subscriptionPortalData[0].itemPrice
              .itemFamilyId - 1;
        }
        this.onTabClick(this.selectedTab);

        this.storage.set('isTrailPeriod', isTrailPeriod);
        this.storage.set(
          'isSubscriptionCancelled',
          this.isSubscriptionCancelled
        );
        if (isTrailPeriod && this.isSubscriptionCancelled) {
          // this.getSubscriptionAddonsData();
        }
      } else {
        this.getSubscriptionAddonsData();
      }
    });
  }

  getSubscriptionAddonsData(): void {
    this.store
      .dispatch(new GetSubscriptionPortalForCapiumAddonsDetails())
      .subscribe((res) => {
        let subscriptionList =
          res.subscriptionPortal.subscriptionPortalDataForCapiumAddons;
        if (subscriptionList.length) {
          let isTrailPeriod =
            res.subscriptionPortal.subscriptionPortalDataForCapiumAddons.some(
              (item: any) => {
                const isTrue =
                  +item.itemPrice.itemId === +SubscriptionsEnum.trail ||
                  +item.status === +PurchasedEnum.Cancelled;

                if (+item.status === +PurchasedEnum.Cancelled) {
                  this.isAddonSubscriptionCancelled = true;
                }
                return isTrue;
              }
            );
          // this.getProjectDetailData('1');

          if (Object.keys(this.storage.get('cartDetails')).length !== 0) {
            this.selectedTab =
              this.storage.get('cartDetails')[0].subscribtionsType;
          } else {
            this.selectedTab =
              res.subscriptionPortal.subscriptionPortalDataForCapiumAddons[0]
                .itemPrice.itemFamilyId - 1;
          }
          this.onTabClick(this.selectedTab);
        } else {
          this.showAddonTab = false;

          if (
            this.storage.get('subscribtionsType') !== null &&
            this.storage.get('subscribtionsType') !== undefined &&
            Object.keys(this.storage.get('cartDetails')).length !== 0
          ) {
            this.selectedTab = this.storage.get('subscribtionsType');
            if (Object.keys(this.storage.get('cartDetails')).length === 0) {
              this.storage.removeItem('subscribtionsType');
            }
          } else {
            this.selectedTab = 0;
          }
          // this.getProjectDetailData('1');

          this.onTabClick(this.selectedTab);
        }
      });
  }

  getProductTabDetails(): void {
    this.store
      .dispatch(new GetProductTabDetails())
      .pipe(
        tap((res) => {
          this.productDataList = res.product.productList;
          this.getSubscriptionData();
        })
      )
      .subscribe();
  }

  toggleReviewOrder(isUpgrade: any): void {
    this.isPlanUpgraded = isUpgrade;
    this.isShowReviewOrder = !this.isShowReviewOrder;
  }

  getProjectDetailData(id: string): void {
    this.spinner.show();
    this.store.dispatch(new GetProductList(id, this.frequency)).subscribe();
  }

  getProjectIndividualDetailData(id: string): void {
    this.spinner.show();
    this.store.dispatch(new GetIndividualProductList(id, this.frequency)).subscribe();
  }

  getSmeProjectDetailData(id: string): void {
    this.spinner.show();
    this.store.dispatch(new GetSmeProductList(id, this.frequency)).subscribe();
  }
  getSmeSubscriptionDetailData() {
    this.store.dispatch(new GetSmeSubscriptionPortalDetails()).subscribe((x) => {
      console.log(x);
      if (x.smeproduct.smeSubscriptionPortalData.length > 0) {
        let isTrailPeriod = x.smeproduct.smeSubscriptionPortalData.some(
          (item: any) => {
            const isTrue =
              +parseInt(item.itemPrice.itemId) === +SMESubscriptionsEnum.trail ||
              +parseInt(item.status) === +PurchasedEnum.Cancelled;

            if (+parseInt(item.status) === +PurchasedEnum.Cancelled) {
              this.isSubscriptionCancelled = true;
            }

            return isTrue;
          }
        );

        this.disableButton =
          !isTrailPeriod && !this.isSubscriptionCancelled ? true : false;
        console.log(this.disableButton);

        this.showAddonTab = !isTrailPeriod && !this.isSubscriptionCancelled;

        this.setFrequency(
          x.smeproduct.smeSubscriptionPortalData[0].itemPrice.periodUnit,
          x.smeproduct.smeSubscriptionPortalData[0].itemPrice.period
        );
        this.isSMEShow = true;

        if (Object.keys(this.storage.get('cartDetails')).length !== 0) {
          this.selectedTab =
            this.storage.get('cartDetails')[0].subscribtionsType;
        } else {
          this.selectedTab =
            x.smeproduct.smeSubscriptionPortalData[0].itemPrice.itemFamilyId -
            1;
        }
        this.onTabClick(this.selectedTab);

        this.storage.set('isTrailPeriod', isTrailPeriod);
        this.storage.set(
          'isSubscriptionCancelled',
          this.isSubscriptionCancelled
        );
      } else {
        this.isSMEShow = true;
      }
    });
  }

  onCancel(): void {
    this.isShowReviewOrder = false;
  }

  onTabClick(event: any): void {
    if (this.selectedTab !== undefined) {
      this.selectedTab = event;
    }
    this.onFrequencyChange(this.frequency, false);
  }

  onFrequencyChange(value, isFilterChanges: boolean) {
    const sessionFrequency = this.storage.get('frequency');

    if (isFilterChanges) {
      this.frequency = this.normalizeFrequency(
        value?.value,
        PeriodUnitType.Month
      );
      this.storage.removeItem('cartDetails');
      this.globalComponent.totalCartItem.next(0);
      this.storage.removeItem('fullSuiteAddonList');
    } else {
      this.frequency = this.normalizeFrequency(
        sessionFrequency,
        this.normalizeFrequency(value, PeriodUnitType.Month)
      );
    }

    this.addonFrequency = this.frequency;
    this.capium365Frequency = this.frequency;
    this.storage.set('frequency', this.frequency);

    if (!this.isSME) {
      if (this.selectedTab === 2) {
        this.productAddonsDetails.ngOnInit();
      } else if (this.selectedTab === 1) {
        this.productIndividualDetails.frequency = this.frequency;
        this.productIndividualDetails.ngOnInit();
      } else if (this.selectedTab === 3) {
        this.productCapium365Component.ngOnInit();
      } else {
        this.productDetails.frequency = this.frequency;
        this.productDetails.ngOnInit();
        const cartDetails = this.storage.get('cartDetails');
        if (Array.isArray(cartDetails)) {
          this.commonService.storeCartItemDataLocally(cartDetails);
        }
      }
    }

    if (sessionFrequency != this.frequency) {
      this.storage.removeItem('cartDetails');
      this.globalComponent.totalCartItem.next(0);
    }
  }
}
